module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container_com-fundo card-dados card-dados_imovel"
  }, [_c('h2', {
    staticClass: "titulo titulo_grande u-margem-inferior-media"
  }, [_vm._v("\n    Dados do imóvel\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "linha-de-dados"
  }, [_c('span', {
    staticClass: "item-de-dado item-de-dado_largo"
  }, [_c('strong', [_vm._v("Construtora:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.construtora.Nome))])])]), _vm._v(" "), _c('div', {
    staticClass: "linha-de-dados"
  }, [_c('span', {
    staticClass: "item-de-dado"
  }, [_c('strong', [_vm._v("CNPJ:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.construtora.Cnpj))])]), _vm._v(" "), _c('span', {
    staticClass: "item-de-dado"
  }, [_c('strong', [_vm._v("Conta vinculada:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.construtora.Conta))])])]), _vm._v(" "), _c('div', {
    staticClass: "linha-de-dados"
  }, [_c('span', {
    staticClass: "item-de-dado"
  }, [_c('strong', [_vm._v("Cidade:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.cidade.Nome + " - " + _vm.cidade.EstadoNome))])]), _vm._v(" "), _c('span', {
    staticClass: "item-de-dado"
  }, [_c('strong', [_vm._v("Tipo de empreendimento:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.empreendimento.TipoDeEmpreendimento))])])]), _vm._v(" "), _c('div', {
    staticClass: "linha-de-dados"
  }, [_c('span', {
    staticClass: "item-de-dado item-de-dado_largo"
  }, [_c('strong', [_vm._v("Nome do empreendimento:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.empreendimento.Nome))])])]), _vm._v(" "), _c('div', {
    staticClass: "linha-de-dados"
  }, [_c('span', {
    staticClass: "item-de-dado item-de-dado_largo"
  }, [_c('strong', [_vm._v("Endereço:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.imovel.EnderecoCompleto))])])]), _vm._v(" "), _c('div', {
    staticClass: "linha-de-dados"
  }, [_c('span', {
    staticClass: "item-de-dado"
  }, [_c('strong', [_vm._v("Valor da compra e venda:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.valorDaCompraEVenda))])]), _vm._v(" "), _c('span', {
    staticClass: "item-de-dado"
  }, [_c('strong', [_vm._v("Participação do proponente:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.participacaoDoSolicitante))])])]), _vm._v(" "), _c('div', {
    staticClass: "linha-de-dados"
  }, [_c('span', {
    staticClass: "item-de-dado"
  }, [_c('strong', [_vm._v("Financiamento concedido:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.valorDoFinanciamentoAprovado))])]), _vm._v(" "), _c('span', {
    staticClass: "item-de-dado"
  }, [_c('strong', [_vm._v("Aporte/subsídio da AGEHAB:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.subsidioDaAgehab))])])]), _vm._v(" "), _c('div', {
    staticClass: "linha-de-dados"
  }, [_c('span', {
    staticClass: "item-de-dado"
  }, [_c('strong', [_vm._v("Subsídio do Governo Federal:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.subsidioDoGovernoFederal))])]), _vm._v(" "), (!_vm.solicitacaoEhDoBonusMoradia) ? _c('span', {
    staticClass: "item-de-dado"
  }, [_c('strong', [_vm._v("FGTS do proponente a utilizar:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fgtsDoSolicitante))])]) : _vm._e(), _vm._v(" "), (_vm.solicitacaoEhDoBonusMoradia) ? _c('span', {
    staticClass: "item-de-dado"
  }, [_c('strong', [_vm._v("Desconto da construtora:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.descontoDaConstrutora))])]) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-39e14a04", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39e14a04"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/controle-de-solicitacoes/detalhes-da-solicitacao/components/DadosDoImovel.vue
// module id = 1109
// module chunks = 1